import React from 'react'
import clsx from 'clsx'

import { Container } from './container'

// A page section: the background band, the vertical rhythm and the container,
// in one place. Vertical spacing between sections is NOT the section's
// business - do not add margins. See assets/styles/primitives.css.
//
//   <Section id="how-it-works" background="stone">...</Section>
//
// `background` is 'paper' (default) or 'stone'. `centred` is for the final
// CTA only (design direction 7.7): it is the one centred section on the page.
// `width="read"` narrows the container. Pass `contain={false}` when the
// section needs to bleed past 1200px (a scroll-snap photo row on a phone)
// and manage its own container inside.
export const Section = ({
  background = 'paper',
  centred = false,
  width,
  contain = true,
  className,
  children,
  ...rest
}) => {
  const content = contain ? <Container width={width}>{children}</Container> : children

  return (
    <section
      className={clsx(
        'gwmc-section',
        background === 'stone' && 'gwmc-section--stone',
        centred && 'gwmc-section--centred',
        className
      )}
      {...rest}>
      {content}
    </section>
  )
}
